export default {"src":"/_next/static/media/app-notification.7e4a4a1d.svg","height":24,"width":24};